import { service_url } from "@/api/config";
import Http from "../api/http";

export function getTariffs() {
  return Http._axios({
    url: `${service_url}/api/v1/payments/tariffs/`,
    method: "get",
  });
}
export function subsctibeTariff(data) {
  return Http._axios({
    url: `${service_url}/api/v1/payments/tariffs/subscribe/`,
    method: "post",
    data,
  });
}

export function unsubscribeTariff(data) {
  return Http._axios({
    url: `${service_url}/api/v1/tariffs/unsubscribe/`,
    method: "post",
    data,
  });
}
